
<div [formGroup]="filtri">


    <div class="flex flex-column align-items-left mb-5 pt-5">


        <div class="flex align-items-left  mb-5 sm:mb-0">

            <div class="sm:mr-3">
              <span class="p-input-icon-left p-input-icon-right p-float-label">
                  <i class="pi pi-search"></i>
                  <input type="text" id="patternRicerca" class="shadow-4" pInputText formControlName="pattern" />
                  <label for="patternRicerca">Cerca</label>
                  <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
              </span>
            </div>



        </div>

    </div>


    <div class="flex align-items-center justify-content-center sm:justify-content-start mb-5 flex-wrap gap-3">


          <div >
            <p-dropdown [options]="formatoComunicazione" formControlName="formatoComunicazione" placeholder="Formato" [showClear]="true"></p-dropdown>
          </div>

          <div >
            <p-dropdown [options]="tipoComunicazione" formControlName="tipoComunicazione" placeholder="Tipo" [showClear]="true"></p-dropdown>
          </div>

          <div class="mr-3">
            <p-calendar
                formControlName="dataDa"
                dateFormat="dd/mm/yy"
                inputId="dataDa"
                [iconDisplay]="'input'"
                placeholder="dal"
                [showIcon]="true"
            ></p-calendar>
          </div>

          <div class="mr-3">
            <p-calendar
                formControlName="dataAl"
                dateFormat="dd/mm/yy"
                inputId="dataAl"
                [iconDisplay]="'input'"
                placeholder="al"
                [showIcon]="true"
            ></p-calendar>
          </div>

          <p-button
          class="clearFiltri"
          size="small"
          [outlined]="true"
          icon="pi pi-filter-slash"
          (click)="clearFilters()"
          pTooltip="Pulisci Filtri"
          tooltipPosition="right"
      />



    </div>

</div>



<div class="mb-5">

    <!-- PAGINATOR della tabella -->
    <div class="flex justify-content-start">
      <p-paginator
          [rows]="pageSize"
          [first]="currentPage"
          [rowsPerPageOptions]="[25, 100, 250, 500]"
          (onPageChange)="pageChange($event)"
          [totalRecords]="totaleDati"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} di {totalRecords}"
          [showPageLinks]="false"
      >
      </p-paginator>
    </div>

</div>

<!-- tabella -->
<div>
    <p-table
    #dt
    [value]="lista"
    [rowHover]="true"
    (onLazyLoad)="ordinamento($event)"
    [customSort]="true"
    [lazy]="true"
    [sortField]="orderColumnName"
    [sortOrder]="orderCustom(order)"
    >
    <!-- headers -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="formato" class="white-space-nowrap">
          Formato <p-sortIcon field="formato"></p-sortIcon>
        </th>
        <th pSortableColumn="tipo" class="white-space-nowrap">
          Tipo <p-sortIcon field="tipo"></p-sortIcon>
        </th>
        <th pSortableColumn="destinatario" class="white-space-nowrap">
          Destinatario <p-sortIcon field="destinatario"></p-sortIcon>
        </th>
        <th pSortableColumn="oggetto" class="white-space-nowrap">
          Oggetto <p-sortIcon field="oggetto"></p-sortIcon>
        </th>
        <th pSortableColumn="esito" class="white-space-nowrap">
          Stato <p-sortIcon field="esito"></p-sortIcon>
        </th>
        <th pSortableColumn="invio" class="white-space-nowrap">
          Data/ora invio <p-sortIcon field="invio"></p-sortIcon>
        </th>
        <th pSortableColumn="avvisi" class="white-space-nowrap">
          Avvisi <p-sortIcon field="avvisi"></p-sortIcon>
        </th>

      </tr>
    </ng-template>

    <!-- rows -->
    <ng-template pTemplate="body" let-item>

        <tr>
            <!-- id?: number;
            esito?: number;
            iscrittoId?:number;
            mittente?: string;
            destinatario?: string;
            dataInvio?: string;
            oggetto?: string;
            dettaglioEsito?: string;
            dataUltimoTentativo?: string; -->
            <td>{{ item.formatoComunicazione }}</td>

            <td>{{ item.tipoComunicazione }}</td>

            <!-- <td>{{ item.mittente }}</td> -->
            <td>{{ item.destinatario }}</td>
            <td>{{ item.oggetto }}</td>
            <td>
              @switch (item.esito) {
                @case (0) {
                  <i class="pi pi-hourglass"></i>
                }
                @case (1) {
                  <i class="pi pi-send"></i>
                }
                @case (2) {
                  <i class="pi pi-times"></i>
                }
              }


            </td>


            <td>{{ getDataInvio(item) }}</td>
            <td>{{ item.dettaglioEsito }}</td>

        </tr>
    </ng-template>
    </p-table>

</div>

<p-toast position="bottom-center"></p-toast>

